import { useAlertsInbox } from '../../api/hooks';
import AcademicDashboard from './AcademicDashboard';
import NeedsYouToday from './sections/NeedsYouToday';
import WrittenToMarkRow from './sections/WrittenToMarkRow';
import { useStudentLookup } from './sections/useStudentLookup';

export default function TeacherDashboard() {
  const alerts = useAlertsInbox({});
  const students = useStudentLookup();
  return <AcademicDashboard title="My dashboard" scopeNote="your grades and subjects" showQuickActions={false} aside={<WrittenToMarkRow />}
    focus={<NeedsYouToday title="Your attention list" alerts={alerts.data?.results ?? []} students={students} />} />;
}
